var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabletHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.1 14.3H39.9V88.04H134.1V14.3Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 98.5L4.40002 107.9V73.5L17.5 98.5Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.433608,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.3 140.3L127.1 144.8L93.7 144.5L95.2 134.7L128.3 140.3Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 107.8L106.7 86.9C106.7 86.9 107.9 77.7 111.4 77.7C114.9 77.7 113.8 87.1 113.8 87.1L112.4 106.2",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103 107.8L106.7 86.9C106.7 86.9 107.9 77.7 111.4 77.7C114.9 77.7 113.8 87.1 113.8 87.1L112.4 106.2",
    stroke: "white",
    strokeWidth: 0.289072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 58.9L20.9 51.8C20.9 51.8 30.5 46.5 32.6 49.9C34.7 53.3 27.1 58.9 27.1 58.9Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.289072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9 49.2V11.9C27.8998 10.1402 28.592 8.451 29.8269 7.19734C31.0619 5.94369 32.7405 5.22622 34.5 5.19995H140.9C142.66 5.22622 144.338 5.94369 145.573 7.19734C146.808 8.451 147.5 10.1402 147.5 11.9V90.2C147.5 91.9504 146.805 93.6291 145.567 94.8669C144.329 96.1046 142.65 96.8 140.9 96.8H121.1",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.1 96.7999H34.5C32.7496 96.7999 31.0709 96.1045 29.8331 94.8668C28.5954 93.6291 27.9 91.9503 27.9 90.1999V66.8999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.1 54.8C142.481 54.8 143.6 53.6808 143.6 52.3C143.6 50.9193 142.481 49.8 141.1 49.8C139.719 49.8 138.6 50.9193 138.6 52.3C138.6 53.6808 139.719 54.8 141.1 54.8Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.3 88.2L112.4 106.2C112.4 106.2 118.1 104.7 119.7 109C124.6 107.5 127 112.2 127 112.2C132 111.4 132.9 115.8 131.9 118.4C130.9 121 123.7 140 123.7 140",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98 135.8L95.8 117C95.4 113.3 103 107.8 103 107.8L106.1 88.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7 61.2999L19 53.6999C19 53.6999 30.6 46.6999 32.6 49.8999C34.6 53.0999 27.8 58.2999 27.8 58.2999L17.9 65.4999L16.5 76.9999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 94.2L26.9 88.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 40.7L2.5 62.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletHands);
export default __webpack_public_path__ + "static/media/tablet_hands.9f6855cf2d89023f23c9728c2a562d75.svg";
export { ForwardRef as ReactComponent };